// hgci-2017, when the DOM is ready
document.addEventListener('DOMContentLoaded', function(){

	// Check if we are on a touch device
	document.documentElement.className += "ontouchstart" in document.documentElement ? ' touch' : ' no-touch';

	// Check if an anchor is used in the URL to open a country
	if ( window.location.hash !== '' ){
		var hash = window.location.hash.substr(1).toUpperCase();
		var countryCodes = [ 'VN','ZA','CN','GH','MZ','TZ','UG','PH','KE','ID','LR','ET','IN','SL','BD','CD','PK','NG' ];

		if ( countryCodes.indexOf( hash ) > -1 ) {
			document.getElementById( hash ).classList.add( 'active' );
		}
	}

	// Get all the countries, and made them clickable
	var countries = document.querySelectorAll('#hgci-2017 .country');
	for (var i = countries.length - 1; i >= 0; i--) {
		countries[i].addEventListener('click', function(){
			this.parentElement.classList.toggle('active');
			window.location.hash = '#' + this.parentElement.id;

			// Analytics
			if(this.parentElement.classList.contains('active')){
				dataLayer.push({
				  'category': 'Interactive',
				  'action': 'CountryClicked',
				  'label': this.parentElement.id,
				  'event': 'Interactive'
				});
			}
		});
	}

	// Get all the countries close button
	var closeCountries = document.querySelectorAll('#hgci-2017 ul > li > a');
	for ( i = closeCountries.length - 1; i >= 0; i-- ) {
		closeCountries[i].addEventListener('click', function(e){
			e.preventDefault();
			this.parentElement.classList.toggle('active');
			window.location.hash = '';
		});
	}

	/*
	// Data for the indicators
	var dataIndicators = {
		"country-commitment": [
			{
				"score": "Participation in International Organization",
				"name": "National-level participation in international financial inclusion-oriented organizations or networks",
				"description": "Has the country signed the Alliance for Financial Inclusion's Maya Declaration on Financial Inclusion or joined international groups such as the Better Than Cash Alliance or the G20’s Financial Inclusion Peer Learning Program?",
				"scoring": "1=No; 3=Yes",
				"sources": "Information for this indicator is based on the online membership listings for the Alliance for Financial Inclusion, the Maya Declaration on Financial Inclusion, and the Better Than Cash Alliance, as well as information regarding participation in the G20’s Financial Inclusion Peer Learning Program."
			},
			{
				"score": "Financial Inclusion Strategy",
				"name": "Existence of a national financial inclusion strategy",
				"description": "Does a comprehensive national financial inclusion strategy exist?",
				"scoring": "1=No; 2=A national financial inclusion strategy is in development; 3=Yes",
				"notes": "As noted in the Alliance for Financial Inclusion’s “Financial Inclusion Strategies: Global Trends and Lessons Learnt from the AFI Network” presentation, comprehensive national financial inclusion strategies may be presented within a national financial sector development plan or as a standalone strategy.",
				"sources": "Information for this indicator was primarily derived from surveys of the Alliance for Financial Inclusion’s “2015 Maya Declaration Progress Report: Commitments into Action;” the Alliance for Financial Inclusion Financial Inclusion Strategy Peer Learning Group’s “A Timeline of Achievement” and “National Financial Inclusion Strategies: Current State of Practice” documents; the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion;” evaluations of online content available from governmental and INGO websites; and information provided by government officials within select FDIP countries."
			},
			{
				"score": "Quantified Targets",
				"name": "Existence of quantifiable financial inclusion targets",
				"description": "Do formal, publicly available quantifiable goals related to financial inclusion exist at a national level?",
				"scoring": "1=No; 3=Yes",
				"notes": "While many countries have developed action items related to financial inclusion that contain general timelines for completion, this indicator specifically focuses on numerical targets. For the purposes of this study, macroeconomic goals, such as an increase in the percentage of savings as GDP, and goals related solely to microfinance (in the narrow sense of microloans) were not included in our evaluation of quantifiable financial inclusion goals.",
				"sources": "Information for this indicator was primarily based on the Alliance for Financial Inclusion’s “2015 Maya Declaration Progress Report: Commitments into Action,” with surveys of governmental authorities’ websites, news reports, INGO websites, and correspondence with country contacts deployed as supplementary data."
			},
			{
				"score": "Financial Services Survey",
				"name": "Existence of a recent demand-side financial services survey conducted or supported by a&nbsp;government&nbsp;entity",
				"description": "Has a nationally representative, demand-side financial services survey been recently conducted or supported by a government entity within the country?",
				"scoring": "1=No; 3=Yes",
				"notes": "For purposes of this study, “recent” refers to surveys published within the previous four years (i.e., surveys published prior to 2012 are not considered recent). “Conducted or supported” in this context signifies that the government either commissioned the survey or was explicitly noted as a partner institution by the lead institution conducting the survey.",
				"sources": "The predominant sources consulted for this indicator include the Alliance for Financial Inclusion’s “2015 Maya Declaration Progress Report: Commitments into Action” and the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion.” Other supplementary sources include surveys of governmental authorities’ and INGO’s websites, as well as correspondence with government representatives in various FDIP focus countries."
			},
			{
				"score": "Dedicated Financial Inclusion Body",
				"name": "Existence of a dedicated financial inclusion body within the public sector",
				"description": "Does the country have a dedicated financial inclusion body within the regulator, ministry of finance, or other governmental entity?",
				"scoring": "1=No; 2=A dedicated final inclusion body is in development; 3=Yes",
				"notes": "Where a dedicated financial inclusion body was not in place, but evidence of dedicated staff coupled with active financial inclusion initiatives was available, we awarded a score of 3.",
				"sources": "The primary source consulted for this indicator was the World Bank’s “Financial Inclusion Strategies Database,” which features more than 50 countries that have either “made formal commitments under the Alliance for Financial Inclusion’s Maya Declaration or have been identified by the Financial Inclusion Strategy Peer Learning Group as having significant national strategies.” Supplementary sources include searches of governmental websites, a review of the Alliance for Financial Inclusion’s “2015 Maya Declaration Progress Report: Commitments into Action,” and correspondence with government representatives."
			},
			{
				"score": "Consumer Protection Framework",
				"name": "Existence of a consumer protection framework regarding financial services",
				"description": "Is a financial consumer protection framework in place?",
				"scoring": "1=No; 2=A specialized financial consumer protection framework is in development or finalized but not yet fully implemented OR certain financial consumer protection provisions are in place; 3=A financial consumer protection framework is in effect.",
				"sources": "The primary source consulted for this indicator was the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion.” Supplementary sources included surveys of publicly available consumer protection regulations, news sources, and analyses from multinational organizations."
			}
		],

		"mobile-capacity": [
			{
				"score": "Unique Mobile Subscribership",
				"name": "Market penetration with respect to unique subscribers",
				"description": "GSMA Intelligence defines this indicator as \"Total subscribers in the market divided by the total population at the end of the period, expressed as a percentage.\" As noted by the GSMA, \"[s]ubscribers differ from connections such that a unique user can have multiple connections.\"",
				"scoring": "1=0-33%; 2=34-66%; 3=67-100%",
				"sources": "GSMA Intelligence Database, 2016. "
			},{
				"score": "3G Mobile Network Coverage",
				"name": "3G mobile coverage by population",
				"description": "“3G mobile coverage, expressed as a percentage of the total market population, at the end of the period,” according to the GSMA.",
				"scoring": "1=0-33%; 2=34-66%; 3=67-100%",
				"sources": "GSMA Intelligence Database, 2016."
			},{
				"score": "Smartphone Adoption",
				"name": "Smartphone adoption",
				"description": "According to the GSMA, this indicator is defined as \"[s]martphone connections expressed as a percentage share of total connections (excluding M2M). It is not calculated as smartphone connections divided by total population.\"",
				"scoring": "1=0-33%; 2=34-66%; 3=67-100%",
				"sources": "GSMA Intelligence Database, 2016. "
			},{
				"score": "Bill Payments",
				"name": "Availability of bill payments via mobile money services",
				"description": "Do mobile money service providers offer bill payment services?",
				"scoring": "1=No; 3=Yes",
				"sources": "GSMA Mobile Money for the Unbanked Deployment Tracker, 2016."
			},{
				"score": "International Remittances",
				"name": "Availability of international remittances via mobile money services",
				"description": "Do mobile money service providers offer international remittances?",
				"scoring": "1=No; 3=Yes",
				"sources": "GSMA Mobile Money for the Unbanked Deployment Tracker, 2016."
			},{
				"score": "Merchant Payments",
				"name": "Availability of merchant payments via mobile money services",
				"description": "Are merchant payments available via mobile money services?",
				"scoring": "1=No; 3=Yes",
				"sources": "GSMA Mobile Money for the Unbanked Deployment Tracker, 2016."
			}
		],

		"regulatory-environment": [
			{
				"score": "Agent Banking",
				"name": "Agent banking",
				"description": "Can banks or other formal financial institutions contract with other legal entities to serve as agents to provide financial services?",
				"scoring": "1=No; 3=Yes",
				"sources": "Sources used to score this indicator include the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion,” surveys of country-specific legislation, news reports, INGO publications, and correspondence with in-country experts."
			},{
				"score": "MNO-led Mobile Money",
				"name": "Mobile network operator-led mobile financial service deployments",
				"description": "Are mobile network operators eligible to apply for licenses or other formal approval from the regulator to lead mobile money deployments?",
				"scoring": "1=No; 3=Yes",
				"sources": "Scoring for this indicator is based primarily on the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion,” surveys of country-specific legislation, news reports, INGO publications, and correspondence with in-country experts."
			},{
				"score": "E-Money Regulations",
				"name": "E-money regulations",
				"description": "Have regulations, policies, or other guidance concerning electronic money (e-money) been issued?",
				"scoring": "1=No e-money regulations are in place or appear to be in development; 2=E-money regulations are in development; 3=E-money regulations have been issued.",
				"sources": "Scoring for this indicator is primarily based on analysis from the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion,” in addition to surveys of relevant regulations on governmental websites and correspondence with government representatives."
			},{
				"score": "Platform Interoperability",
				"name": "Mobile money platform interoperability",
				"description": "Is the capacity for mobile money platform interoperability required by the regulator or other financial inclusion authority and/or are mobile money platforms actively interoperable?",
				"scoring": "1=No requirements concerning the capacity for platform interoperability have been issued by the regulator, and there is no evidence of interoperability; 2=Platforms are explicitly required to have the capacity for interoperability OR efforts to develop an interoperable platform have been advanced significantly; 3=Two or more mobile money platforms are actively interoperable.",
				"notes": "While there are numerous types of interoperability, for the purposes of this study we focus on platform interoperability, in which mobile money platforms are interconnected so that a “customer with an account with one service provider can send or receive money to or from the account of a customer with a different service provider.”",
				"sources": "The predominant sources consulted for this indicator were surveys of regulations on governmental websites, news articles, INGO and industry publications, and correspondence with in-country experts. This research was supplemented with surveys of the Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion.” "
			},{
				"score": "Account Access and Usage",
				"name": "Account access and usage",
				"description": "Are account opening and usage requirements (e.g., know-your-customer processes and minimum balance requirements) for savings products at regulated financial institutions conducive to the adoption of these products by underserved populations?",
				"scoring": "1=No/Somewhat; 3=Yes",
				"sources": "The Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion” was the main resource consulted for this indicator. Correspondence with country contacts and reviews of country-specific regulations, INGO and industry reports, and news articles served as supplementary sources."
			},{
				"score": "Cash-in/Cash-out",
				"name": "Cash-in/cash-out at agent locations",
				"description": "Are agents permitted to perform both cash-in and cash-out services within the context of an inclusive regulatory environment?",
				"scoring": "1=Agents are not permitted to perform cash-in and cash-out services; 2=Agents are permitted to perform cash-in and cash-out services, but regulations constrain the entry of certain agents into the market; 3=Agents are permitted to perform cash-in and cash-out services within the context of an inclusive regulatory environment",
				"sources": "The Economist Intelligence Unit’s “Global Microscope 2015: The Enabling Environment for Financial Inclusion” served as the main source for this indicator, in addition to surveys of news articles, websites of industry associations and financial service providers, correspondence with in-country experts, and studies conducted by non-government entities."
			}
		],

		"adoption": [
			{
				"score": "Financial Institution Account Penetration-Lower-income Adults",
				"name": "Formal financial institution account penetration among lower-income adults",
				"description": "The 2014 Global Findex description for the data used for this indicator is “percentage of respondents who report having an account (by themselves or together with someone else) at a bank or another type of financial institution; having a debit card in their own name; receiving wages, government transfers, or payments for agricultural products into an account at a financial institution in the past 12 months; paying utility bills or school fees from an account at a financial institution in the past 12 months; or receiving wages or government transfers into a card in the past 12 months (income, poorest 40%, % age 15+).”",
				"scoring": "1=5-22%; 2=23-40%; 3=41-58%"
			},{
				"score": "Financial Institution Account Penetration-Women",
				"name": "Formal financial institution account penetration among women",
				"description": "The 2014 Global Findex description for the data used for this indicator \"denotes the percentage of respondents who report having an account (by themselves or together with someone else) at a bank or another type of financial institution; having a debit card in their own name; receiving wages, government transfers, or payments for agricultural products into an account at a financial institution in the past 12 months; paying utility bills or school fees from an account at a financial institution in the past 12 months; or receiving wages or government transfers into a card in the past 12 months (female, % age 15+).”",
				"scoring": "1=3-24%; 2=25-47%; 3=48-69%"
			},{
				"score": "Borrowing from a Financial Institution",
				"name": "Borrowing from a financial institution",
				"description": "The 2014 Global Findex description for the data used for this indicator is the percentage of adults who “borrowed any money in the past 12 months (by themselves or together with someone else) from a bank or another type of financial institution. This does not include the use of credit cards.”",
				"scoring": "1=2-7%; 2=8-14%; 3=15-20%"
			},{
				"score": "Saving at a Financial Institution",
				"name": "Saving at a financial institution",
				"description": "The 2014 Global Findex description for the data used for this indicator is the percentage of respondents who “report saving or setting aside any money in the past 12 months by using an account at a bank or another type of financial institution (% age 15+).”",
				"scoring": "1=3-12%; 2=13-23%; 3=24-33%"
			},{
				"score": "Debit Card Use",
				"name": "Debit card use",
				"description": "The 2014 Global Findex description for the data used for this indicator is “the percentage of respondents who report using their own debit card directly to make a purchase in the last 12 months (% age 15+).”",
				"scoring": "1=0-13%; 2=14-28%; 3=29-42%"
			},{
				"score": "Credit Card Use",
				"name": "Credit card use",
				"description": "The 2014 Global Findex description for the data used for this indicator is “the percentage of respondents who report using their own credit card in the past 12 months (% age 15+).”",
				"scoring": "1=0-9%; 2=10-19%; 3=20-29%"
			},{
				"score": "Online Bill Payment and Purchases",
				"name": "Percentage of adults utilizing online bill payments and purchases",
				"description": "The 2014 Global Findex description for the data used for this indicator is the percentage of adults who reported “paying bills or making purchases online using the Internet in the past 12 months (% age 15+).”",
				"scoring": "1=0-5%; 2=6-13%; 3=14-19%"
			},{
				"score": "Mobile Money Account Penetration-Lower-Income Adults",
				"name": "Mobile money account penetration among lower-income adults",
				"description": "The 2014 Global Findex description for the data used for this indicator is the “percentage of respondents who report personally using a mobile phone to pay bills or to send or receive money through a GSM Association (GSMA) Mobile Money for the Unbanked (MMU) service in the past 12 months; or receiving wages, government transfers, or payments for agricultural products through a mobile phone in the past 12 months (income, lowest 40%, % age 15+).”",
				"scoring": "1=0-17%; 2=18-35%; 3=36-53%"
			},{
				"score": "Mobile Money Account Penetration-Women",
				"name": "Mobile money account penetration among women",
				"description": "The 2014 Global Findex description for the data used for this indicator is the percentage of women who “personally us[ed] a mobile phone to pay bills or to send or receive money through a mobile money service in the previous 12 months or who received wages, government transfers, or payments for agricultural products through a phone in the previous 12 months.”",
				"scoring": "1=0-17%; 2=18-37%; 3=38-55%"
			},{
				"score": "Mobile Salary/Wage Receipt",
				"name": "Mobile phone used to receive salary or wages (among recent wage-earners)",
				"description": "The 2014 Global Findex description for the data used for this indicator reads “among respondents who reported receiving any money from an employer in the past 12 months in the form of a salary or wages for doing work, percentage of adults who received salary or wages through a mobile phone in the last 12 months.”",
				"scoring": "1=0-7%; 2=8-17%; 3=18-25%"
			},{
				"score": "Mobile Utility Payments",
				"name": "Mobile phone used to make utility payments (among adults regularly making utility bill payments)",
				"description": "The 2014 Global Findex description for the data used for this indicator \"denotes, among respondents reporting personally making regular payments in the past 12 months for water, electricity, or trash collection, the percentage who made these payments through a mobile phone (% paying utility bills, age 15+).”",
				"scoring": "1=0-17%; 2=18-37%; 3=38-55%"
			},{
				"score": "Frequency of Account Usage",
				"name": "Frequency of account usage",
				"description": "The 2014 Global Findex description for the data used for this indicator is “the percentage of respondents with an account at a bank or another type of financial institution who report that money is withdrawn from their account three or more times in a typical month (% with an account, age 15+).”",
				"scoring": "1=3-12%; 2=13-22%; 3=23-32%"
			}
		]
	};

	// Get all the indicators, and made them clickable
	var indicators = document.querySelectorAll('#hgci-2017 ol li');
	for ( i = indicators.length - 1; i >= 0; i-- ) {

		// Click Event to open the 'information' div
		indicators[i].addEventListener('click', function(){

			// Show the 'information' div
			this.classList.toggle('active');

			var innerHTML = '';
			// If it is getting opened, we are filling the 'information' div with the relevant information
			if(this.classList.contains('active')){

				// Analytics
				dataLayer.push({
					'category': 'Interactive',
					'action': 'IndicatorExpanded',
					'label': this.parentElement.parentElement.parentElement.parentElement.id + '|' + this.classList[0],
					'event': 'Interactive'
				});

				// Get the category, and which indicator it is
				var category = this.classList[0].split('_');
				// Get all the info about it
				var information = dataIndicators[category[0]][category[1]];

				// description
				if(information.description != undefined){
					innerHTML += '<p><strong>Description</strong>' + information.description + '</p>'
				}

				// scoring
				if(information.scoring != undefined){
					innerHTML += '<p><strong>Scoring</strong>' + information.scoring + '</p>'
				}

				// notes
				if(information.notes != undefined){
					innerHTML += '<p><strong>Notes</strong>' + information.notes + '</p>'
				}

				// sources
				if(information.sources != undefined){
					innerHTML += '<p><strong>Sources</strong>' + information.sources + '</p>'
				}

				// add the information content
				this.insertAdjacentHTML('beforeend','<div class="information">' + innerHTML + '</div>');

			} else {
				// Empty the 'information' box
				this.getElementsByClassName('information')[0].remove();
			}
		});
	}
	*/
}, false); // end of hgci-2017
